/**
 * Search modal empty state — trending “best seller” products (Dawn-style).
 * Scoped to #search-modal. Edit GRAPHQL_ENDPOINT / TOKEN / COLLECTION_HANDLE below.
 */
(function () {
  'use strict';

  const GRAPHQL_ENDPOINT = 'https://www.titanwatches.ae/api/2023-07/graphql.json';
  const STOREFRONT_ACCESS_TOKEN = 'aae586c3f2a11452b05ecadcc9ce121d';
  const COLLECTION_HANDLE = 'all-products';
  const CACHE_KEY = 'header:trending-best-seller:v5';
  const MIN_SLIDES = 4;
  const MAX_SLIDES = 8;

  let trendingProductsSwiperInstance = null;
  let renderBusy = false;

  window.__404HTMLCache = window.__404HTMLCache || {
    read(key) {
      try {
        const raw = sessionStorage.getItem(key);
        if (!raw) return null;
        const parsed = JSON.parse(raw);
        const maxAgeMs = 1000 * 60 * 30;
        if (Date.now() - (parsed.ts || 0) > maxAgeMs) return null;
        return parsed.html || null;
      } catch (_) {
        return null;
      }
    },
    write(key, html) {
      try {
        sessionStorage.setItem(key, JSON.stringify({ ts: Date.now(), html: html }));
      } catch (_) {}
    },
  };

  function getModalRoot() {
    return document.getElementById('search-modal');
  }

  function getTrendingContainer() {
    const root = getModalRoot();
    if (!root) return null;
    return root.querySelector('#trending-best-seller-products-header');
  }

  function parseRuntime() {
    const el = document.getElementById('predictive-search-trending-runtime');
    if (!el || !el.textContent) return {};
    try {
      return JSON.parse(el.textContent);
    } catch (_) {
      return {};
    }
  }

  function escapeHtml(str) {
    if (str == null) return '';
    const d = document.createElement('div');
    d.textContent = String(str);
    return d.innerHTML;
  }

  /** Uses window.formatMoney when present (e.g. homepage-dynamic); else Shopify-style cents from runtime.moneyFormat */
  function formatMoneyCents(cents, runtime) {
    if (typeof window.formatMoney === 'function') {
      try {
        const fmt = (runtime && runtime.moneyFormat) || window.money_format;
        return window.formatMoney(cents, fmt);
      } catch (_) {}
    }
    const moneyFormat = (runtime && runtime.moneyFormat) || '{{amount}}';
    const n = Number(cents);
    if (Number.isNaN(n)) return '';
    const amount = (n / 100).toFixed(2);
    return String(moneyFormat).replace(/\{\{\s*amount\s*\}\}/gi, amount);
  }

  function waitForSwiper(cb) {
    if (typeof Swiper !== 'undefined') {
      cb();
      return;
    }
    let n = 100;
    (function poll() {
      if (typeof Swiper !== 'undefined') {
        cb();
        return;
      }
      if (--n <= 0) {
        cb();
        return;
      }
      setTimeout(poll, 40);
    })();
  }

  function initTrendingProductsSwiper() {
    const root = getModalRoot();
    if (!root) return;
    const trendingProductsSwiper = root.querySelector('.trending-products-swiper');
    if (!trendingProductsSwiper || typeof Swiper === 'undefined') return;
    if (trendingProductsSwiperInstance) return;

    trendingProductsSwiperInstance = new Swiper(trendingProductsSwiper, {
      slidesPerView: 'auto',
      spaceBetween: 0,
      loop: false,
      watchSlidesProgress: true,
      watchSlidesVisibility: true,
      navigation: {
        nextEl: root.querySelector('.trending-products-next'),
        prevEl: root.querySelector('.trending-products-prev'),
      },
      scrollbar: {
        el: root.querySelector('.trending-products-scrollbar'),
        draggable: true,
      },
      breakpoints: {
        320: { slidesPerView: 'auto', spaceBetween: 0 },
        600: { slidesPerView: 'auto', spaceBetween: 0 },
        768: { slidesPerView: 'auto', spaceBetween: 0 },
        1024: { slidesPerView: 'auto', spaceBetween: 0 },
        1280: { slidesPerView: 'auto', spaceBetween: 0 },
      },
      a11y: false,
      cssMode: false,
      mousewheel: { forceToAxis: true },
      keyboard: { enabled: true },
    });
  }

  function destroyTrendingProductsSwiper() {
    if (trendingProductsSwiperInstance && typeof trendingProductsSwiperInstance.destroy === 'function') {
      try {
        trendingProductsSwiperInstance.destroy(true, true);
      } catch (_) {}
    }
    trendingProductsSwiperInstance = null;
  }

  function parseCardPriceFromEl(el) {
    if (!el) return 0;
    const matches = String(el.textContent || '')
      .replace(/,/g, '')
      .match(/[\d]+(?:\.[\d]+)?/g);
    if (!matches || !matches.length) return 0;
    return parseFloat(matches[matches.length - 1]) || 0;
  }

  function buildSearchTrendingDiscountBlock(priceNum, compareAtPriceNum, runtime, productTags, vendor, titleHint) {
    return buildDiscountStripHtml(priceNum, compareAtPriceNum, runtime, productTags, vendor, titleHint);
  }

  function ensureSearchTrendingDiscountStrips() {
    const container = getTrendingContainer();
    if (!container) return;
    const runtime = parseRuntime();

    container.querySelectorAll('.card-wrapper').forEach(function (card) {
      const content = card.querySelector('.card__content');
      if (!content) return;

      const priceNum = parseCardPriceFromEl(card.querySelector('.price-item--sale, .price-item--last'));
      const compareAtPriceNum = parseCardPriceFromEl(card.querySelector('.price-item--regular'));
      if (!(priceNum > 0)) return;

      const vendor = String(card.getAttribute('data-vendor') || '').trim();
      const titleEl = card.querySelector('.card__heading a, .card__heading, h3 a, h3');
      const titleHint = titleEl ? String(titleEl.textContent || '').trim() : '';
      const stripHtml = buildSearchTrendingDiscountBlock(
        priceNum,
        compareAtPriceNum,
        runtime,
        null,
        vendor,
        titleHint
      );
      if (!stripHtml) return;

      const existingStrip = content.querySelector('.card-discount-saving-strip');
      const imageWrap = content.querySelector('.card-discount-msg-image');

      if (existingStrip) return;

      if (imageWrap) {
        const img = imageWrap.querySelector('img');
        const replaceWithStrip = function () {
          if (content.querySelector('.card-discount-saving-strip')) return;
          const wrap = document.createElement('div');
          wrap.innerHTML = stripHtml;
          const strip = wrap.firstElementChild;
          if (strip) imageWrap.replaceWith(strip);
        };

        if (!img || !img.getAttribute('src')) {
          replaceWithStrip();
          return;
        }

        if (img.complete) {
          if (!img.naturalWidth || !img.naturalHeight) replaceWithStrip();
          return;
        }

        img.addEventListener('error', replaceWithStrip, { once: true });
        return;
      }

      const information = content.querySelector('.card__information');
      if (!information) return;
      const wrap = document.createElement('div');
      wrap.innerHTML = stripHtml;
      const strip = wrap.firstElementChild;
      if (strip) information.insertAdjacentElement('afterend', strip);
    });

    if (typeof window.upgradeLegacyCardDiscountMsgs === 'function') {
      window.upgradeLegacyCardDiscountMsgs(container);
    }
  }

  function upgradeSearchTrendingDiscountStrips() {
    ensureSearchTrendingDiscountStrips();
  }

  /** Emit .card-discount-saving-strip for Nebula Flat % or Save when compare-at is higher. */
  function buildDiscountStripHtml(priceNum, compareAtPriceNum, runtime, productTags, vendor, titleHint) {
    if (typeof window.getCardDiscountMsgHtmlFromPrices === 'function') {
      const stripHtml = window.getCardDiscountMsgHtmlFromPrices(
        priceNum,
        compareAtPriceNum,
        productTags,
        vendor,
        titleHint
      );
      if (stripHtml && stripHtml.indexOf('card-discount-saving-strip') !== -1) {
        return stripHtml;
      }
      // Shared helper returned empty (Nebula with no compare-at, excluded tags, etc.)
      if (typeof window.isNebulaProduct === 'function' && window.isNebulaProduct(vendor, productTags, titleHint)) {
        return '';
      }
      if (
        typeof window.shouldHideCardDiscountStripForTags === 'function' &&
        window.shouldHideCardDiscountStripForTags(productTags)
      ) {
        return '';
      }
    } else if (
      typeof window.shouldHideCardDiscountStripForTags === 'function' &&
      window.shouldHideCardDiscountStripForTags(productTags)
    ) {
      return '';
    }

    if (!compareAtPriceNum || compareAtPriceNum <= priceNum) return '';
    if (
      typeof window.shouldShowCardDiscountSavingStrip === 'function' &&
      !window.shouldShowCardDiscountSavingStrip(priceNum, compareAtPriceNum)
    ) {
      return '';
    }

    const savings = Math.floor(compareAtPriceNum - priceNum);
    if (savings <= 0) return '';

    const savingsDisplay = formatMoneyCents(savings * 100, runtime).replace(/\.00$/, '');
    let style =
      '--discount-strip-color:#fcdbd1;background:linear-gradient(90deg,#fcdbd1 0%,rgba(252,219,209,0.5) 50%,transparent 100%);';
    if (typeof window.getCardDiscountMsgStyle === 'function') {
      style = window.getCardDiscountMsgStyle(savings);
    }

    let iconHtml = '';
    const iconTpl = document.getElementById('card-discount-tag-icon-svg');
    if (iconTpl && iconTpl.textContent) {
      iconHtml = iconTpl.textContent.trim();
    }

    return (
      '<div class="card-discount-saving-strip pdp-discount-saving-strip" style="' +
      style +
      '"><span class="card-discount-saving-strip__icon" aria-hidden="true">' +
      iconHtml +
      '</span><p class="card-discount-msg">Save <span class="card-discount-msg__price">' +
      escapeHtml(savingsDisplay) +
      '</span></p></div>'
    );
  }

  function reloadSearchTrendingWishlist() {
    if (typeof ReloadSmartWishlist === 'function') {
      try {
        ReloadSmartWishlist();
      } catch (_) {}
    }
  }

  function scheduleInitSwiper() {
    setTimeout(function () {
      waitForSwiper(function () {
        destroyTrendingProductsSwiper();
        initTrendingProductsSwiper();
        upgradeSearchTrendingDiscountStrips();
        reloadSearchTrendingWishlist();
      });
    }, 100);
  }

  function fetchWithTimeout(url, options, timeoutMs) {
    const ms = timeoutMs || 4000;
    const controller = new AbortController();
    const id = setTimeout(function () {
      controller.abort();
    }, ms);
    return fetch(url, Object.assign({}, options, { signal: controller.signal })).finally(function () {
      clearTimeout(id);
    });
  }

  function fetchCollectionProducts(handle, collected, afterCursor) {
    const acc = collected || [];
    const query = `
          query ($handle: String!, $afterCursor: String) {
            collection(handle: $handle) {
              products(first: 100, after: $afterCursor) {
                pageInfo { hasNextPage endCursor }
                edges {
                  node {
                    id
                    title
                    handle
                    vendor
                    tags
                    totalInventory
                    images(first: 1) { edges { node { url altText } } }
                    priceRange { minVariantPrice { amount } }
                    variants(first: 1) {
                      edges {
                        node {
                          id
                          sku
                          compareAtPrice { amount }
                        }
                      }
                    }
                    metafield(namespace: "custom", key: "product_card_offer_strip") { value }
                  }
                }
              }
            }
          }
        `;

    return fetchWithTimeout(GRAPHQL_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': STOREFRONT_ACCESS_TOKEN,
      },
      body: JSON.stringify({ query: query, variables: { handle: handle, afterCursor: afterCursor } }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('API ' + res.status);
        return res.json();
      })
      .then(function (json) {
        if (json.errors && json.errors.length) {
          throw new Error(json.errors.map(function (e) { return e.message; }).join('; '));
        }
        if (!json.data || !json.data.collection) return acc;

        const edges = json.data.collection.products && json.data.collection.products.edges ? json.data.collection.products.edges : [];
        const pageInfo = json.data.collection.products && json.data.collection.products.pageInfo ? json.data.collection.products.pageInfo : {};

        edges.forEach(function (edge) {
          const node = edge.node;
          const v0 = node.variants && node.variants.edges && node.variants.edges[0] && node.variants.edges[0].node;
          const firstImg =
            node.images && node.images.edges && node.images.edges[0] && node.images.edges[0].node
              ? node.images.edges[0].node
              : null;
          const firstUrl = firstImg && firstImg.url ? firstImg.url : '';
          acc.push({
            productId: node.id,
            title: node.title,
            handle: node.handle,
            vendor: node.vendor,
            tags: node.tags || [],
            totalInventory: node.totalInventory || 0,
            image: firstUrl,
            imageAlt: firstImg && firstImg.altText ? firstImg.altText : '',
            price: Number(node.priceRange && node.priceRange.minVariantPrice && node.priceRange.minVariantPrice.amount ? node.priceRange.minVariantPrice.amount : 0),
            compareAtPrice: Number(v0 && v0.compareAtPrice && v0.compareAtPrice.amount ? v0.compareAtPrice.amount : 0),
            variantId: v0 && v0.id ? v0.id : null,
            sku: v0 && v0.sku ? v0.sku : '',
            productCardStripImage: node.metafield && node.metafield.value ? node.metafield.value : '',
          });
        });

        if (pageInfo.hasNextPage && pageInfo.endCursor) {
          return fetchCollectionProducts(handle, acc, pageInfo.endCursor);
        }
        return acc;
      });
  }

  function buildSlideElement(p, runtime) {
    const imageUrl = p.image || 'https://via.placeholder.com/300';
    const imageAltText = escapeHtml(p.imageAlt || p.title || '');
    let prefix = (runtime && runtime.productUrlPrefix) || '/products/';
    if (!prefix.endsWith('/')) {
      prefix = prefix + '/';
    }
    const productUrl = prefix + String(p.handle).replace(/^\/+/, '');
    const productIds = p.productId ? String(p.productId).split('/').pop() : '';
    const variantIds = p.variantId ? String(p.variantId).split('/').pop() : '';
    const priceNum = Number(p.price);
    const compareAtPriceNum = Number(p.compareAtPrice || 0);
    const finalPrice = formatMoneyCents(priceNum * 100, runtime).replace(/\.00$/, '');
    const cmpPrice = formatMoneyCents(compareAtPriceNum * 100, runtime).replace(/\.00$/, '');

    const labelTag = p.tags.find(function (tag) {
      return String(tag).includes('Label_') && !String(tag).includes('#');
    });
    const labelValue = labelTag ? String(labelTag).replace('Label_', '').trim() : '';

    let coloredLabelHTML = '';
    const colorLabel = p.tags.find(function (tag) {
      return String(tag).includes('Label_') && String(tag).includes('#');
    });
    if (colorLabel) {
      const baseTag = String(colorLabel).replace('Label_', '').trim();
      const tagParts = baseTag.split(' ');
      const tagColor = tagParts[tagParts.length - 1];
      if (/^#([0-9A-F]{3}){1,2}$/i.test(tagColor)) {
        const tagText = tagParts.slice(0, -1).join(' ');
        coloredLabelHTML = `<span class="revamp-product-tags custom-label-tag" style="background-color: ${escapeHtml(tagColor)};">${escapeHtml(tagText)}</span>`;
      }
    }

    let freeGiftMsg = '';
    if (window.freeGiftMinValue && priceNum > 0) {
      const freeGiftCount = Math.floor(priceNum / window.freeGiftMinValue);
      if (freeGiftCount > 0) {
        const giftSVG = `<svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
              <path d="M15.3333 3.3337H13.7367C13.8973 3.0161 13.9872 2.6674 14 2.3117C13.9769 1.6829 13.7077 1.0883 13.2505 0.656027C12.7932 0.223737 12.1845 -0.0116928 11.5553 0.00044723C10.806 0.0327172 10.0794 0.267877 9.4532 0.680807C8.8271 1.0937 8.3248 1.669 8 2.345C7.6787 1.6708 7.1802 1.0966 6.5579 0.683647C5.9356 0.270697 5.2128 0.0345472 4.4667 0.00044723C4.4413 0.00044723 4.416 0.00044723 4.3907 0.00044723C3.7705 0.00143723 3.1749 0.242827 2.7291 0.673857C2.2833 1.1049 2.0219 1.692 2 2.3117V2.3557C2.013 2.6961 2.0992 3.0296 2.2527 3.3337H0.6667C0.4899 3.3337 0.3203 3.4039 0.1953 3.5289C0.0702001 3.654 0 3.8235 0 4.0003V6.0003C0 6.1771 0.0702001 6.3466 0.1953 6.4717C0.3203 6.5967 0.4899 6.6669 0.6667 6.6669H15.3333C15.5101 6.6669 15.6797 6.5967 15.8047 6.4717C15.9298 6.3466 16 6.1771 16 6.0003V4.0003C16 3.8235 15.9298 3.654 15.8047 3.5289C15.6797 3.4039 15.5101 3.3337 15.3333 3.3337ZM11.576 1.3337C11.8483 1.3267 12.113 1.424 12.3158 1.6059C12.5186 1.7877 12.6441 2.0403 12.6667 2.3117C12.6572 2.5846 12.5427 2.8433 12.347 3.0337C12.1514 3.2241 11.8897 3.3316 11.6167 3.3337H8.9853C9.4 2.4944 10.2247 1.3337 11.576 1.3337ZM3.3333 2.3337C3.3504 2.0609 3.4715 1.8051 3.6718 1.619C3.872 1.4329 4.136 1.3308 4.4093 1.3337C5.7887 1.3391 6.5967 2.4877 7.016 3.3337H4.416C4.1423 3.3357 3.878 3.2335 3.6769 3.0478C3.4758 2.8621 3.353 2.6067 3.3333 2.3337Z" fill="#A01000"/>
              <path d="M9.33203 8V15.9998H12.6653C13.1957 15.9998 13.7044 15.7891 14.0795 15.414C14.4546 15.039 14.6653 14.5303 14.6653 13.9999V8H9.33203Z" fill="#A01000"/>
              <path d="M6.66533 8H1.33203V13.9999C1.33203 14.5303 1.54273 15.039 1.91773 15.414C2.29283 15.7891 2.80153 15.9998 3.33203 15.9998H6.66533V8Z" fill="#A01000"/>
            </svg>`;
        if (window.freeGiftMaxValue && priceNum >= window.freeGiftMaxValue) {
          freeGiftMsg = `<p class="card-discount-msg"><span class="gift-svg">${giftSVG}</span> Enjoy 6 Free Tanishq Lamp</p>`;
        } else {
          freeGiftMsg = `<p class="card-discount-msg"><span class="gift-svg">${giftSVG}</span> Enjoy ${freeGiftCount} Free Tanishq Lamp</p>`;
        }
      }
    }

    const discount =
      compareAtPriceNum && compareAtPriceNum > priceNum
        ? Math.round(((compareAtPriceNum - priceNum) / compareAtPriceNum) * 100)
        : 0;

    const saleBlock =
      compareAtPriceNum > priceNum
        ? `<span class="price-item price-item--sale price-item--last">${finalPrice}</span><span><s class="price-item price-item--regular">${cmpPrice}</s></span>`
        : `<span class="price-item price-item--sale price-item--last">${finalPrice}</span>`;

    const gtmAttr = typeof window.handleGTMProductClicked === 'function' ? ' onclick="handleGTMProductClicked(this)"' : '';
    const imgSrcAttr = String(imageUrl).replace(/"/g, '&quot;');

    const badgeParts = [];
    if (labelValue) {
      badgeParts.push('<span class="revamp-product-tags">' + escapeHtml(labelValue) + '</span>');
    }
    if (coloredLabelHTML) {
      badgeParts.push(coloredLabelHTML);
    }
    const badgeStackHtml =
      badgeParts.length > 0
        ? '<div class="search-trending-card-badge-stack">' + badgeParts.join('') + '</div>'
        : '';

    const wishlistHtml = productIds
      ? `<span class="product-card-wishlist"><span class="smartwishlist" data-product="${escapeHtml(productIds)}" data-variant="${escapeHtml(variantIds)}"></span></span>`
      : '';

    const html = `
            <div class="card-wrapper product-card-wrapper revamp-product-card-container underline-links-hover" data-product="${escapeHtml(productIds)}" data-product-sku="${escapeHtml(p.sku || '')}" data-product-title="${escapeHtml(p.title || '')}" data-vendor="${escapeHtml(p.vendor || '')}"${gtmAttr}>
              <div class="card card--standard card--media" style="--ratio-percent: 100%;">
                <div class="card__inner ratio" style="--ratio-percent: 100%;">
                  <div class="card__media">
                    <a href="${escapeHtml(productUrl)}" class="full-unstyled-link">
                      <div class="media media--transparent card-gallery">
                        <div class="product-media" style="--ratio: 1.0">
                          <img
                            src="${imgSrcAttr}"
                            alt="${imageAltText}"
                            loading="lazy"
                            width="1500"
                            height="1500"
                            sizes="auto, (min-width: 750px) 50vw, 100vw"
                            class="product-media__image motion-reduce"
                            fetchpriority="low"
                            style="position: unset; --focal-point: 50% 50%;"
                          >
                        </div>
                        ${badgeStackHtml}
                      </div>
                    </a>
                  </div>
                  ${wishlistHtml}
                </div>
                <div class="card__content">
                  <div class="card__information">
                    <h3 class="card__heading h5"><a href="${escapeHtml(productUrl)}" class="full-unstyled-link">${escapeHtml(p.title)}</a></h3>
                    <div class="price price--on-sale">
                      <div class="price__container">
                        <div class="price__sale">
                          ${saleBlock}
                        </div>
                      </div>
                    </div>
                  </div>
                  ${buildSearchTrendingDiscountBlock(priceNum, compareAtPriceNum, runtime, p.tags, p.vendor, p.title)}
                  ${freeGiftMsg}
                </div>
              </div>
            </div>
          `;

    const wrap = document.createElement('div');
    wrap.className = 'swiper-slide revamp-product-card-container';
    wrap.innerHTML = html.trim();

    return wrap;
  }

  window.renderTrendingBestSellerProducts = async function () {
    if (renderBusy) return;
    const container = getTrendingContainer();
    if (!container) return;

    const tpl = document.getElementById('predictive-search-trending-fallback-slides');
    const originalHTML = tpl && tpl.innerHTML ? tpl.innerHTML : container.innerHTML;
    const runtime = parseRuntime();

    if (runtime.useFallbackCollection) {
      container.innerHTML = originalHTML;
      scheduleInitSwiper();
      return;
    }

    renderBusy = true;
    try {
      try {
        sessionStorage.removeItem('header:trending-best-seller');
      } catch (_) {}

      const cached = window.__404HTMLCache.read(CACHE_KEY);
      if (
        cached &&
        cached.indexOf('card-discount-saving-strip') !== -1 &&
        cached.indexOf('smartwishlist') !== -1
      ) {
        container.innerHTML = cached;
        scheduleInitSwiper();
        return;
      }

      const allProductsRaw = await fetchCollectionProducts(COLLECTION_HANDLE, [], null);

      const productMap = new Map();
      allProductsRaw.forEach(function (product) {
        if (!productMap.has(product.handle)) productMap.set(product.handle, product);
      });
      const allProducts = Array.from(productMap.values());

      const filteredProducts = allProducts.filter(function (p) {
        const tagsLower = p.tags.map(function (t) {
          return String(t).toLowerCase();
        });
        return (
          tagsLower.indexOf('featured') >= 0 &&
          tagsLower.indexOf('clearance') < 0 &&
          tagsLower.indexOf('flash-sale') < 0 &&
          p.totalInventory >= 2
        );
      });

      const discountFiltered = filteredProducts.filter(function (p) {
        if (!p.compareAtPrice || p.compareAtPrice <= p.price) return false;
        const discountPercent = ((p.compareAtPrice - p.price) / p.compareAtPrice) * 100;
        return discountPercent <= 33;
      });

      const topProducts = discountFiltered.slice(0, MAX_SLIDES);

      if (topProducts.length < MIN_SLIDES) {
        container.innerHTML = originalHTML;
        scheduleInitSwiper();
        return;
      }

      container.innerHTML = '';
      topProducts.forEach(function (p) {
        container.appendChild(buildSlideElement(p, runtime));
      });

      window.__404HTMLCache.write(CACHE_KEY, container.innerHTML);
      scheduleInitSwiper();
    } catch (err) {
      const c2 = getTrendingContainer();
      if (c2) {
        c2.innerHTML = originalHTML;
      }
      scheduleInitSwiper();
    } finally {
      renderBusy = false;
    }
  };

  /** Debounce so morph + focus churn does not queue duplicate runs */
  let emptyStateDebounce = null;
  function scheduleRenderFromEmptyState() {
    clearTimeout(emptyStateDebounce);
    emptyStateDebounce = setTimeout(function () {
      window.renderTrendingBestSellerProducts();
    }, 50);
  }

  function bind() {
    const modal = getModalRoot();
    if (modal) {
      modal.addEventListener('dialog:open', function () {
        window.renderTrendingBestSellerProducts();
      });
    }
    window.addEventListener(
      'predictive-search:empty-state-rendered',
      scheduleRenderFromEmptyState
    );
    window.addEventListener(
      'DOMContentLoaded',
      function () {
        window.renderTrendingBestSellerProducts();
      },
      { once: true }
    );
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind, { once: true });
  } else {
    bind();
  }
})();
